import './styles.scss'

import React from 'react'
import { useValues } from 'kea'
import { hot } from 'react-hot-loader'

import I18n from 'lib/i18n'
import Widget from 'lib/tags/widget'
import BreakOnBr from 'lib/tags/break-on-br'
import FullScreen from 'lib/components/full-screen'

import Methods from './methods'

import Logo from './../shared/logo'

import Form from './form'

import logic from './logic'

const Signup = () => {
  const { formVisible, notice, isEmailOnly } = useValues(logic)

  return (
    <div className='registration-signup-scene'>
      <FullScreen />
      <Widget>
        <Logo isEmailOnly={isEmailOnly} />
        <div className='inside-widget'>
          {notice && !formVisible && (
            <h6>
              <BreakOnBr text={notice} />
            </h6>
          )}

          {formVisible ? <Form /> : <Methods />}

          {!isEmailOnly && (
            <div className='login-link'>
              {I18n.t('devise.registrations.already_have_account')}{' '}
              <a href='/login'>{I18n.t('devise.registrations.already_have_account_log_in')}</a>
            </div>
          )}
        </div>
      </Widget>
    </div>
  )
}

export default hot(module)(Signup)
